/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
//import { Dropdown } from "react-bootstrap";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { getPath, SidebarMenu } from "../../../utils/constants";
import { isMobile } from "react-device-detect";
//import LogoutPage from './Logout';

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = ({ notificationCounts = {} }) => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  const path = getPath();

  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }, []);
  let scrollPosition = useScrollPosition();

  const handleMinimizeMenu = () => {
    if (isMobile) {
      document.getElementById("nav-burger").click();
    }
  };

  // Function to get notification count for a menu item
  const getNotificationCount = (menuKey) => {
    return notificationCounts[menuKey] || 0;
  };

  return (
    <div
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM className="metismenu" id="menu">
          {SidebarMenu().map((item, index) => {
            const notificationCount = item.isNotification
              ? getNotificationCount(item.key)
              : 0;

            return (
              <li
                key={index}
                className={`${
                  item.allowActive.includes(path) ? "mm-active" : ""
                }`}
                onClick={handleMinimizeMenu}
              >
                <Link to={item.url} className="ai-icon">
                  <i className={item.icon}></i>
                  <span className="nav-text">{item.label}</span>
                  {/* Notification Badge */}
                  {item.isNotification && notificationCount > 0 && (
                    <span className="notification-badge">
                      {notificationCount > 99 ? "99+" : notificationCount}
                    </span>
                  )}
                </Link>
                {item?.subMenu.length > 0 && (
                  <ul>
                    {item.subMenu.map((itemSub, indexSub) => {
                      const subNotificationCount = itemSub.isNotification
                        ? getNotificationCount(itemSub.key)
                        : 0;

                      return (
                        <li key={indexSub} style={{ fontWeight: 500 }}>
                          <Link
                            className={`${
                              "/" + path === itemSub.url ? "mm-active" : ""
                            }`}
                            to={itemSub.url}
                          >
                            {itemSub.label}
                            {/* Submenu Notification Badge */}
                            {itemSub.isNotification &&
                              subNotificationCount > 0 && (
                                <span className="notification-badge notification-badge-sub">
                                  {subNotificationCount > 99
                                    ? "99+"
                                    : subNotificationCount}
                                </span>
                              )}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </MM>
        <div style={{ padding: '20px 15px', marginTop: '10px' }}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              const host = window.location.hostname;
              const nextHost = host.includes('stg.')
                ? 'www.stg.new.sistemklinik.com'
                : host.startsWith('preprod.')
                  ? 'preprod.new.sistemklinik.com'
                  : 'www.new.sistemklinik.com';
              // Read Supabase session from supabase-js v2 storage key (sb-{ref}-auth-token).
              // We hand the tokens to Next.js via URL hash; Next's /sso-receive
              // page calls supabase.auth.setSession() to mirror them into its own SDK.
              const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
              const projectRef = (() => {
                try { return new URL(supabaseUrl).hostname.split('.')[0]; } catch { return null; }
              })();
              const storageKey = projectRef ? `sb-${projectRef}-auth-token` : null;
              const rawSession = storageKey ? localStorage.getItem(storageKey) : null;
              let session = null;
              try { session = rawSession ? JSON.parse(rawSession) : null; } catch (_) { session = null; }
              if (session?.access_token && session?.refresh_token) {
                const params = new URLSearchParams({
                  supabase_access_token: session.access_token,
                  supabase_refresh_token: session.refresh_token,
                  redirect: '/dashboard',
                });
                window.location.href = `https://${nextHost}/sso-receive#${params.toString()}`;
              } else {
                window.location.href = `https://${nextHost}`;
              }
            }}
            style={{
              display: 'block',
              textAlign: 'center',
              padding: '12px 20px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
          >
            🚀 Try New Version
          </a>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
